import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { CheckCircle2, ShieldCheck, Clock, Home } from "lucide-react";

const HC_IMG = "https://images.unsplash.com/photo-1582560475093-ba66accbc424?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function HomeCollectionSection({ onBook }) {
  const { t } = useLang();
  const points = [
    { icon: ShieldCheck, text: "Safe & hygienic sample collection" },
    { icon: Clock, text: "Flexible time slots, 7 days a week" },
    { icon: Home, text: "Trained, certified technicians at your door" },
  ];
  return (
    <section id="home-collection" className="py-20 md:py-28" data-testid="home-collection-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="relative">
          <div className="rounded-[2rem] overflow-hidden shadow-[0_30px_70px_-25px_rgba(10,37,64,0.4)]">
            <img src={HC_IMG} alt="Home blood sample collection" className="w-full h-[360px] md:h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-5 left-6 bg-white rounded-2xl px-5 py-4 shadow-xl border border-slate-100 flex items-center gap-3" data-testid="hc-badge">
            <span className="w-11 h-11 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600"><Home className="w-5 h-5" /></span>
            <div><p className="font-bold text-navy text-sm">Free Pickup</p><p className="text-xs text-secondary">at your doorstep</p></div>
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-turq-dark">{t("hc_label")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-3 tracking-tight">{t("hc_title")}</h2>
          <p className="text-secondary mt-5 text-lg leading-relaxed">{t("hc_text")}</p>
          <ul className="mt-7 space-y-4">
            {points.map((p) => (
              <li key={p.text} className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-turq/10 flex items-center justify-center text-turq-dark shrink-0"><p.icon className="w-4.5 h-4.5" strokeWidth={1.8} /></span>
                <span className="text-navy font-medium">{p.text}</span>
              </li>
            ))}
          </ul>
          <button onClick={onBook} className="mt-8 inline-flex items-center gap-2 bg-turq hover:bg-turq-dark text-white rounded-full px-8 py-4 font-medium transition-all hover:-translate-y-0.5 shadow-[0_10px_30px_rgba(0,180,216,0.3)]" data-testid="hc-book-btn">
            <Home className="w-5 h-5" /> {t("book_home_collection")}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
